import { CMD_SERVER_URL } from "../env"
import { cmdApi } from './axios';

export async function detectMode() {
    if (!CMD_SERVER_URL) {
        console.warn('REACT_APP_CMD_SERVER_URL não configurada, caindo para modo offline.');
        return 'offline';
    }

  try {
    const response = await cmdApi.get('/health', { timeout: 2000 });
    if (response.status === 200) {
      return 'online';
    }
  } catch (error) {
    console.warn('CMD server indisponível, usando modo offline.', error?.message || error);
  }

  return 'offline';
}